<template>
  <!-- Referral program page (iframe) -->
  <router-view v-if="$route.path === '/referral-program'" />
  
  <!-- All other pages (with header) -->
  <div
    v-else
    class="grid grid-rows-[50px_auto_1fr] grid-cols-1 md:grid-rows-[68px_1fr] md:has-[.bottom-status-bar]:grid-rows-[68px_1fr_36px] md:min-h-dvh md:min-h-screen md:max-h-dvh md:max-h-screen md:isolate md:z-0 md:gap-x-1 isolate">
    <LandingPageHeader />
    <main
      class="pt-6 px-4 md:row-start-2 md:col-start-1 md:pt-[60px] md:px-10 md:overflow-hidden z-10 bg-interactive-interactiveBg">
      <div class="h-full overflow-auto no-scrollbar md:max-w-[76.375rem] md:mx-auto">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import LandingPageHeader from './components/LandingPageHeader.vue'

export default {
  name: 'App',
  components: {
    LandingPageHeader
  }
}
</script>

<style>
/* Глобальные стили будут подключены через index.html */
</style>
